import { clearCelebrationLedgers } from '@savvy-kit/foundations/motion/celebration-session';
import { isNil } from 'es-toolkit';
import { handleMutationError } from 'src/utils/handle-mutation-error';

import { CurrentUserQuery } from '@savvy/deprecated-shared/api/user-api';
import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { loggedInAsAdvisorID, removeLoggedInAsAdvisorID } from '@savvy/deprecated-shared/utils/savvy-auth';
import { useMutationWithErrorLogging } from '@savvy/graphql-hooks/useMutationWithErrorLogging';
import { useQueryWithErrorLogging } from '@savvy/graphql-hooks/useQueryWithErrorLogging';

import { STOP_IMPERSONATING_USER } from '../logout-as-button';

export function useDashboardLogout(onLogOut?: () => void): () => Promise<void> {
  const { logout, user, update } = useAuth();
  const { data: newCurrentUserData, refetch } = useQueryWithErrorLogging(CurrentUserQuery);
  const [stopImpersonatingUser] = useMutationWithErrorLogging(STOP_IMPERSONATING_USER);

  return async () => {
    if (!isNil(loggedInAsAdvisorID())) {
      try {
        await stopImpersonatingUser({ variables: { input: {} } });
        await refetch();
        update({ ...user, newCurrentUserData });
      } catch (err) {
        console.error(err);
      }
      removeLoggedInAsAdvisorID();
    }

    try {
      onLogOut?.();
      clearCelebrationLedgers();
      await logout();
      window.location.href = '/login';
    } catch (err) {
      console.error(err);
      handleMutationError(err, 'Unable to logout.');
    }
  };
}
